// endpoint params with description - used in availableAPIs()
export const params = {
  account: {
    val: 'account',
    desc: 'BridgeGate Workbench Account',
    isOptional: false,
    sample: 'samples',
  },
  account_name: {
    val: 'account_name',
    desc: 'BridgeGate Workbench Account',
    isOptional: false,
    sample: 'samples',
  },
  // user: {
  //   val: 'user',
  //   desc: 'BridgeGate Workbench User',
  //   isOptional: false,
  //   sample: 'admin',

  // },
  workflow_group_name: {
    val: 'workflow_group_name',
    desc: 'Name of Workflow Group',
    isOptional: false,
    sample: 'sample1'
  },
  workflow_name: {
    val: 'workflow_name',
    desc: 'Name of Workflow',
    isOptional: false,
    sample: 'purchaseorders'
  },
  // template_name: {
  //   val: 'template_name',
  //   desc: 'Name of template',
  //   isOptional: false,
  //   sample: 'csvinvoice'
  // },
  structOnly: {
    val: 'structOnly',
    desc: 'string boolean that determines if additional information should be included in the template response',
    isOptional: true,
    sample: 'false'
  },
  debug_action: {
    val: 'debug_action',
    desc: '',
    isOptional: false,
    sample: ''
  },
  template_name: {
    val: 'template_name',
    desc: 'Name of inbound template',
    isOptional: false,
    sample: 'test-sample12'
  },
  outbound: {
    val: 'oubound_template',
    desc: 'Name of outbound template',
    isOptional: false,
    sample: 'newsample'
  },
  WfGroupName_in: {
    val: 'WfGroupName_in',
    desc: '',
    isOptional: false,
    sample: ''
  },
  WfGroupName_out: {
    val: 'WfGroupName_out',
    desc: '',
    isOptional: false,
    sample: ''
  },
  type: {
    val: 'type',
    desc: '',
    isOptional: false,
    sample: ''
  },
  source: {
    val: 'source',
    desc: 'tells the source of an error',
    isOptional: false,
    sample: ''
  },
  message: {
    val: 'message',
    desc: '',
    isOptional: false,
    sample: ''
  },
  lineno: {
    val: 'lineno',
    desc: 'line number where error occurs',
    isOptional: false,
    sample: ''
  },
  colno: {
    val: 'colno',
    desc: 'column number where error occurs',
    isOptional: false,
    sample: ''
  },
  error: {
    val: 'error',
    desc: 'specifies what error has occured',
    isOptional: false,
    sample: ''
  },
  location: {
    val: 'location',
    desc: '',
    isOptional: false,
    sample: ''
  },
  data_type: {
    val: 'data_type',
    desc: 'specifies data type of template, here it is either EDI or HL7',
    isOptional: false,
    sample: 'EDI'
  },
  data_type_version: {
    val: 'data_type_version',
    desc: 'specifies the version of data type for a particular data type',
    isOptional: false,
    sample: '4010'
  },
  template_rename: {
    val: 'template_rename',
    desc: 'new name for a template',
    isOptional: false,
    sample: 'rename_ibTemplate'
  },

  new_workflow_group_name: {
    val: 'new_workflow_group_name',
    desc: 'specifies a new name for a workflow group',
    isOptional: false,
    sample: 'new-name'
  },
  source_account: {
    val: 'source_account',
    desc: 'name of account containg template to be copied',
    isOptional: false,
    sample: 'training'
  },
  source_workflow_group_name: {
    val: 'source_workflow_group_name',
    desc: 'Workflow group name containg source inbound template to be copied',
    isOptional: false,
    sample: 'datatypes'
  },
  source_template_name: {
    val: 'source_template_name',
    desc: 'name of inbound template to be copied',
    isOptional: false,
    sample: 'account_json'
  },
  direction: {
    val: 'direction',
    desc: `'in' for Inbound or 'out' for OutBound`,
    isOptional: false,
    sample: 'IN'
  },
  datatype: {
    val: 'datatype',
    desc: 'specify data type',
    isOptional: false,
    sample: 'database'
  },
  message_type: {
    val: 'message_type',
    desc: 'specify message type for a particular data type Note:- UpperCase Only',
    isOptional: false,
    sample: 'ADT'
  },
  pretty: {
    val: 'pretty',
    desc: 'string boolean for formatted data',
    isOptional: true,
    sample: 'false'
  },
  pluginName: {
    val: 'pluginName',
    desc: 'specify plugin name.',
    isOptional: false,
    sample: 'UpdateTradingPartnerKeyPlugin'
  },
  reportName: {
    val: 'reportName',
    desc: 'specify Report Name.',
    isOptional: false,
    sample: 'editracking'
  },
  statementType: {
    val: 'statementType',
    desc: 'specify Statement Type.',
    isOptional: false,
    sample: 'insert'
  },
  is_overwrite: {
    val: 'is_overwrite',
    desc: 'specify Statement Type.',
    isOptional: true,
    sample: 'yes'
  },
  destination_workflow_group_name: {
    val: 'destination_workflow_group_name',
    desc: 'Workflow group name containg destinationnpm template to be copied.',
    isOptional: false,
    sample: 'database'
  },
  path: {
    val: 'path',
    desc: 'specify file path.',
    isOptional: false,
    sample: 'samples/sample/inbound_templates/test_save_csv.json'
  },
  revid: {
    val: 'revid',
    desc: 'specify revision id',
    isOptional: false,
    sample: '3'
  },
  user_revid: {
    val: 'user_revid',
    desc: 'specify user revision id',
    isOptional: false,
    sample: '1'
  },
  search_str: {
    val: 'search_str',
    desc: 'search string',
    isOptional: false,
    sample: ''
  },
  language: {
    val: 'language',
    desc: 'language',
    isOptional: false,
    sample: 'in'
  },
  table_name: {
    val: 'table_name',
    desc: 'name of table',
    isOptional: false,
    sample: 'bg_accounts_queues'
  },
  pdc_name: {
    val: 'pdc_name',
    desc: 'name of pdc',
    isOptional: false,
    sample: 'MySQL'
  },
  schema: {
    val: 'schema',
    desc: 'schema name',
    isOptional: false,
    sample: 'bridgegate'
  },
  date_pattern: {
    val: 'date_pattern',
    desc: 'pattern of date',
    isOptional: false,
    sample: 'MM/dd/yyyy'
  },
  data_string: {
    val: 'data_string',
    desc: 'string for data',
    isOptional: false,
    sample: '100000000.00'
  },
  pattern: {
    val: 'pattern',
    desc: 'pattern of date',
    isOptional: false,
    sample: '###,###,###.##'
  },
  precision_value: {
    val: 'precision_value',
    desc: 'precise value',
    isOptional: false,
    sample: '0'
  },
  check_box: {
    val: 'check_box',
    desc: 'check_box',
    isOptional: true,
    sample: 'true'
  },
  source_doc: {
    val: 'source_doc',
    desc: 'source of the document',
    isOptional: false,
    sample: '/BridgeGate%20Cloud/Cloud.html'
  },
  keyword: {
    val: 'keyword',
    desc: 'keyword',
    isOptional: false,
    sample: 'FTP'
  },
  root_element: {
    val: 'root_element',
    desc: 'list of elements after uploading valid file.',
    isOptional: false,
    sample: ''
  },
  filename: {
    val: 'filename',
    desc: 'name of the file',
    isOptional: false,
    sample: ''
  },
  exact_portioning_type: {
    val: 'portioning_type',
    desc: 'the portioning type is exact',
    isOptional: false,
    sample: 'Exact'
  },
  relative_portioning_type: {
    val: 'portioning_type',
    desc: 'the portioning type is relative',
    isOptional: false,
    sample: 'Relative'
  },
  start_position: {
    val: 'start_position',
    desc: 'starting postion',
    isOptional: false,
    sample: 1,
    type: 'number'
  },
  no_of_chars: {
    val: 'no_of_chars',
    desc: 'number of characters',
    isOptional: false,
    sample: 4,
    type: 'number'
  },
  parse: {
    val: 'parse',
    desc: 'it is LEFT or RIGHT',
    isOptional: false,
    sample: 'LEFT'
  },
  test_data_exact: {
    val: 'test_data',
    desc: 'data to be tested',
    isOptional: false,
    sample: 'ABc123'
  },
  start_value: {
    val: 'start_value',
    desc: 'starting value',
    isOptional: false,
    sample: '1',
  },
  end_value: {
    val: 'end_value',
    desc: 'end value',
    isOptional: false,
    sample: '9',
  },
  test_data_relative: {
    val: 'test_data',
    desc: 'data to be tested',
    isOptional: false,
    sample: "123456789"
  },
  start_occurrence: {
    val: 'start_occurrence',
    desc: 'occurance at start',
    isOptional: false,
    sample: 1
  },
  end_occurrence: {
    val: 'end_occurrence',
    desc: 'occurance at end',
    isOptional: false,
    sample: 1
  },
  record_delimiter: {
    val: 'record_delimiter',
    desc: 'sequence of chracters to mark end of data record in a file',
    isOptional: false,
    sample: 'CRLF'
  },
  field_delimiter: {
    val: 'field_delimiter',
    desc: 'sequence of chracters used to separate individual data fields within a record',
    isOptional: false,
    sample: ','
  },
  hl7: {
    val: 'hl7',
    desc: 'to verify the template data type, determining if it is HL7 or not, it can be assigned one of two values: N and Y.',
    isOptional: false,
    sample: 'N'
  },
  template_type: {
    val: 'template_type',
    desc: 'to ensures the identification of the template type, whether it is inbound or outbound,it can be assigned one of two values: in and out',
    isOptional: false,
    sample: 'in'
  },
  get_details: {
    val: 'get_details',
    desc: 'to get details of all predefined connections',
    isOptional: false,
    sample: true
  },
  pdc_connection: {
    val: 'name',
    desc: 'name of pdc connection',
    isOptional: false,
    sample: 'MySQLIn'
  },
  old_pdc_connection: {
    val: 'old_pdc_name',
    desc: 'name of old pdc',
    isOptional: false,
    sample: 'testing'
  },
  new_pdc_connection: {
    val: 'name',
    desc: 'name of new pdc',
    isOptional: false,
    sample: 'Copyoftesting'
  },
  adapter_type: {
    val: 'ADAPTER_TYPE',
    desc: 'connection type',
    isOptional: false,
    sample: 'DATABASE'
  },
  database_type: {
    val: 'DATABASE_TYPE',
    desc: 'database type',
    isOptional: false,
    sample: 'MYSQL'
  },
  jdbc_url: {
    val: 'JDBCURL',
    desc: 'jdbc url',
    isOptional: false,
    sample: 'jdbc:mysql://192.168.0.100/bridgegate?useSSL=false'
  },
  username: {
    val: 'USERNAME',
    desc: 'username',
    isOptional: false,
    sample: 'bridgegate'
  },
  password: {
    val: 'PASSWORD',
    desc: 'password',
    isOptional: false,
    sample: 'bridgegate'
  },
  data_depot_name: {
    val: 'data_depot_name',
    desc: 'specify data depot name',
    isOptional: false,
    sample: 'testing'
  },
  data_depot_field_name: {
    val: 'data_depot_field_name',
    desc: 'specify data depot field name',
    isOptional: false,
    sample: 'testing'
  },
  data_depot_field_type: {
    val: 'data_depot_field_type',
    desc: 'specify data depot field type',
    isOptional: false,
    sample: 'ALPHA'
  },
  create_account_data: {
    val: 'create',
    desc: 'add a new key value pair for a account data',
    isOptional: true,
    sample: {'sample1': 'sample1', 'sample2': 'sample2'}
  },
  delete_account_data: {
    val: 'delete',
    desc: 'delete a new key value pair for a account data',
    isOptional: true,
    sample: []
  },
  rename_account_data: {
    val: 'rename',
    desc: 'rename a new key for a account data',
    isOptional: true,
    sample: {}
  },
  update_account_data: {
    val: 'update',
    desc: 'update a new value according to key for a account data',
    isOptional: true,
    sample: {}
  },
  sort: {
    val: 'sort',
    desc: 'sort in order',
    isOptional: false,
    sample: 'false'
  },
  encoding: {
    val: 'encoding',
    desc: 'provide type of encoding',
    isOptional: true,
    sample: 'DEFAULT_ENCODING'
  },
  sql_query: {
    val:'sqlQueryToRun',
    desc: 'sql query to be executed',
    isOptional: false,
    sample: `SELECT * from bg_accounts_queues`
  }
}

// array of all api endpoints with data
export const availableAPIs = [
  {
    val: 'get_workflow',
    category: 'Workflow',
    desc: `It returns a selected workflow's JSON structure`,
    method: 'get',
    params: [
      { ...params.account },
      { ...params.workflow_group_name },
      { ...params.workflow_name }
    ]
  },
  {
    val: 'get_workflows',
    category: 'Workflow',
    method: 'get',
    desc: 'It returns an array of workflows within an account',
    params: [{ ...params.account }]
  },
  {
    val: 'get_inbound_template',
    category: 'Inbound Template',
    method: 'get',
    desc: ' It returns an inbound template tree in the form of JSON',
    params: [
      { ...params.account },
      { ...params.workflow_group_name },
      { ...params.template_name },
      params.structOnly
    ]
  },
  {
    val: "get_outbound_template",
    category: 'Outbound Template',
    method: 'get',
    desc: ' It returns an outbound template tree in the form of JSON',
    params: [
      { ...params.account },
      { ...params.workflow_group_name },
      { ...params.template_name }
    ]
  },
  {
    val: "new_workflow_group",
    category: 'Workflow',
    method: 'get',
    desc: ' This API will create a new workflow group ',
    params: [
      { ...params.account },
      { ...params.workflow_group_name },
    ]
  }, {
    val: "test_workflow_action",
    category: 'Testing Workflows',
    method: 'post',
    desc: 'It notify backend of user stepping to or from test workflow / test template',
    params: [
      params.debug_action,
      { ...params.workflow_name }
    ]
  },
  {
    val: "get_inbound_templates_tree",
    category: 'Inbound Template',
    method: 'get',
    desc: ' It returns an outbound template tree in the form of JSON',
    params: [
      { ...params.account },
    ]
  },
  {
    val: "get_test_templates_for_workflow",
    category: 'Testing Templates',
    method: 'get',
    desc: 'It  returns list of templates in the form of JSON',
    // params: [
    // params.user,
    // ]
  },
  {
    val: "get_test_template_data",
    category: 'Testing Templates',
    method: 'get',
    desc: 'This API will get test data to be passed onto test template page',
    // params: [
    // params.user,
    // ]
  },
  {
    val: "get_outbound_templates_for_inbound",
    category: 'Testing Templates',
    method: 'get',
    desc: 'It returns array of outbound templates based on given inbound template',
    params: [
      { ...params.account },
      { ...params.workflow_group_name },
      { ...params.template_name },
    ]
  },
  {
    val: "save_test_template_settings",
    category: 'Testing Templates',
    method: 'post',
    desc: " This saves user's selected templates to backend ",
    params: [
      { ...params.account },
      { ...params.WfGroupName_in },
      { ...params.WfGroupName_out },
      { ...params.template_name },
      { ...params.outbound },
    ]
  },
  {
    val: "get_template_datatype",
    category: 'Testing Templates',
    method: 'get',
    desc: ' It returns the datatype of an inbound or outbound template',
    params: [
      { ...params.account },
      { ...params.workflow_group_name },
      { ...params.template_name },
    ]
  },
  {
    val: "start_test_template",
    category: 'Testing Templates',
    method: 'post',
    desc: " It starts inbound->outbound template testing in backend",
    params: [
      { ...params.account },
      { ...params.WfGroupName_in },
      { ...params.WfGroupName_out },
      { ...params.template_name },
      { ...params.outbound },
    ]
  },
  {
    val: 'test_template_action',
    category: 'Testing Templates',
    method: 'post',
    desc: ' This is used to notify backend of actions like  next_record, pause, step ,resume and stop',
    params: [
      params.debug_action,
      { ...params.type }
    ]
  },
  {
    val: 'get_template_data',
    category: 'Testing Templates',
    method: 'get',
    desc: 'This API returns inbound or outbound template data, used after test ',
    // params: [
    //   params.user,
    // ]
  },
  {
    val: 'get_test_template_state',
    category: 'Testing Templates',
    method: 'get',
    desc: ' It returns state of current processed TBT session of user',
    // params: [
    //   params.user
    // ]
  },
  {
    val: 'report_js_error',
    category: 'Testing Templates',
    method: 'post',
    desc: ' It sends js error messages to bridgegate asp support ',
    params: [
      params.source,
      params.message,
      params.lineno,
      params.colno,
      params.error
    ]
  },
  {
    val: 'get_workflow_results',
    category: 'Testing Workflows',
    method: 'get',
    desc: 'It return workflow debug result data',
    params: [
      params.location
    ]
  },
  {
    val: 'get_test_workflow_state',
    category: 'Testing Workflows',
    method: 'get',
    desc: " It return a status of user's current workflow debug session ",
    // params: [
    //   params.user
    // ]
  },
  {
    val: 'start_test_workflow_debug',
    category: 'Testing Workflows',
    method: 'post',
    desc: ' This signal the  backend to start debug session on given workflow',
    params: [
      { ...params.account },
      { ...params.workflow_group_name },
      { ...params.workflow_name },
    ]
  },
  {
    val: 'create_outbound_template',
    category: 'Outbound Template',
    method: 'get',
    desc: ' It creates an Outbound template',
    params: [
      { ...params.account },
      { ...params.workflow_group_name },
      { ...params.workflow_name },
      { ...params.outbound }
    ]
  },
  {
    val: 'new_inbound_template',
    category: 'Inbound Template',
    method: 'get',
    desc: 'It creates an Inbound template',
    params: [
      { ...params.account },
      { ...params.workflow_group_name },
      { ...params.template_name }
    ]
  },
  {
    val: 'get_outbound_templates_tree',
    category: 'Outbound Template',
    method: 'get',
    desc: 'It returns list of outbound templates in JSON form',
    params: [
      { ...params.account },
      { ...params.workflow_group_name },
      { ...params.workflow_name }
    ]
  },
  
  {
    val: 'rename_inbound_template',
    category: 'Inbound Template',
    method: 'patch',
    desc: 'This API renames the selected inbound template',
    params: [
      { ...params.account },
      { ...params.workflow_group_name },
      { ...params.template_name },
      params.template_rename,
    ]
  },
  {
    val: 'rename_workflow_group',
    category: 'Workflow',
    method: 'patch',
    desc: 'This API renames the selected workflow group',
    params: [
      { ...params.account },
      { ...params.workflow_group_name },
      { ...params.new_workflow_group_name },
    ]
  },
  {
    val: 'copy_inbound_template',
    category: 'Inbound Template',
    method: 'get',
    desc: 'Copy inbound template API allows a user to make a copy of selected template along with its data',
    params: [
      { ...params.account },
      { ...params.source_account },
      { ...params.source_workflow_group_name },
      { ...params.source_template_name },
      { ...params.workflow_group_name },
      { ...params.template_name }
    ]
  },
  {
    val: 'delete_workflow_group',
    category: 'Workflow',
    method: 'delete',
    desc: 'Delete workflow group action will delete selected workflow group along with schedules,inbound templates and outbound templates it contains',
    params: [
      { ...params.account },
      { ...params.workflow_group_name }
    ]
  },
  {
    val: 'delete_inbound_template',
    category: 'Inbound Template',
    method: 'delete',
    params: [
      { ...params.account },
      { ...params.workflow_group_name },
      { ...params.template_name }
    ],
  },
  {
    val: 'get_account_data',
    category: 'Account Data',
    method: 'get',
    desc: 'Get list of all Account Data in JSON format',
    params: [
      { ...params.account }
    ]
  },
  {
    val: 'modify_account_data',
    category: 'Account Data',
    method: 'post',
    desc: 'This will handle Create, Delete, Rename and Update for a Account Data',
    params: [
      { ...params.account }
    ],
    body: [
      params.create_account_data,
      params.rename_account_data,
      params.update_account_data,
      params.delete_account_data
    ]
  },
  {
    val: 'get_predefined_connections_list',
    category: 'Predefined Connection',
    method: 'get',
    desc: 'Get Predefined Connection will get all predefined connection in JSON format',
    params: [
      { ...params.account },
      params.direction,
      { ...params.datatype },
      { ...params.get_details}
    ]
  },
  {
    val: 'get_predefined_connection',
    category: 'Predefined Connection',
    method: 'get',
    desc: 'Get details of Predefined Connection will get all predefined connection in JSON format',
    params: [
      { ...params.account },
      params.direction,
      { ...params.pdc_connection }
    ]
  },
  {
    val: 'delete_predefined_connection',
    category: 'Predefined Connection',
    method: 'delete',
    desc: 'Delete a Predefined Connection',
    params: [
      { ...params.account },
      params.direction,
      { ...params.pdc_connection }
    ]
  },
  {
    val: 'save_predefined_connection',
    category: 'Predefined Connection',
    method: 'post',
    desc: 'Save Predefined Connection',
    params: [
      { ...params.account },
      params.direction,
      { ...params.old_pdc_connection },
      { ...params.new_pdc_connection}
    ],
    body: [
      params.adapter_type,
      params.database_type,
      params.jdbc_url,
      params.username,
      params.password
    ]
  },
  {
    val: 'test_predefined_connection',
    category: 'Predefined Connection',
    method: 'post',
    desc: 'Test a Predefined Connection to make a successful connection to database',
    params: [
      { ...params.account },
      params.direction,
      { ...params.new_pdc_connection}
    ],
    body: [
      params.adapter_type,
      params.database_type,
      params.jdbc_url,
      params.username,
      params.password
    ]
  },
 
  {
    val: 'get_trading_partner_keys',
    category: 'Trading Partner',
    method: 'get',
    desc: 'It returns trading partner keys in JSON format.',
    params: [
      { ...params.account },
    ]
  },
 
  {
    val: 'get_tracking_reports',
    category: 'Tracking Reports',
    method: 'get',
    desc: 'It returns tracking reports in JSON format.',
    params: [
      { ...params.account },
    ]
  },
  {
    val: 'get_tracking_report_fields',
    category: 'Tracking Reports',
    method: 'get',
    desc: 'It returns fields of tracking report in JSON format.',
    params: [
      { ...params.account },
      params.reportName,
      params.statementType
    ]
  },
  {
    val: 'get_metadata',
    category: 'Database',
    method: 'get',
    desc: 'Get metadata for a database table',
    params: [
      { ...params.account_name },
      { ...params.direction },
      { ...params.pdc_name },
      { ...params.schema },
      { ...params.sort },
      {...params.table_name }
    ]
  },
  {
    val: 'get_top_25_records',
    category: 'Database',
    method: 'get',
    desc: 'Get metadata for a database table',
    params: [
      { ...params.account_name },
      { ...params.encoding },
      { ...params.direction},
      { ...params.pdc_name},
      { ...params.schema},
      { ...params.sort},
      {...params.table_name}
    ]
  },
  {
    val: 'get_sql_result',
    category: 'Database',
    method: 'post',
    desc: 'Execute a SQL query',
    params: [
      { ...params.account_name },
      { ...params.direction},
      { ...params.pdc_name},
      { ...params.encoding },
      { ...params.schema},
    ],
    body: [
      params.sql_query
    ]
  },
  {
    val: 'move_inbound_template',
    category: 'Inbound Template',
    method: 'get',
    desc: 'It returns fields of tracking report in JSON format.',
    params: [
      { ...params.source_workflow_group_name },
      { ...params.destination_workflow_group_name },
      { ...params.template_name },
      { ...params.is_overwrite },
      { ...params.account },
    ]
  },
  {
    val: 'get_template_types',
    category: 'Inbound Template',
    method: 'get',
    desc: 'It returns fields of tracking report in JSON format.',
    params: [
      { ...params.account },
      { ...params.data_type }
    ]
  },
  {
    val: 'get_data_type_versions',
    category: 'Inbound Template',
    method: 'get',
    desc: 'It returns fields of tracking report in JSON format.',
    params: [
      { ...params.account },
      { ...params.data_type }
    ]
  },
  {
    val: 'add_data_depot',
    category: 'Data Depot',
    method: 'get',
    desc: 'It will create a new Data Depot',
    params: [
      { ...params.account },
      { ...params.data_depot_name }
    ],
  },
  {
    val: 'add_data_depot_field',
    category: 'Data Depot',
    method: 'get',
    desc: 'It will create a new Data Depot Field',
    params: [
      { ...params.account },
      { ...params.data_depot_name },
      { ...params.data_depot_field_name },
      { ...params.data_depot_field_type}
    ],
  },
  {
    val: 'delete_data_depot_field',
    category: 'Data Depot',
    method: 'delete',
    desc: 'It will delete Data Depot Field',
    params: [
      { ...params.account },
      { ...params.data_depot_name },
      { ...params.data_depot_field_name }
    ],
  },
  {
    val: 'get_data_depot_list',
    category: 'Data Depot',
    method: 'get',
    desc: 'It returns data depot list.',
    params: [
      { ...params.account },
      params.pretty,
    ]
  },
  {
    val: 'get_data_depot_field_list',
    category: 'Data Depot',
    method: 'get',
    desc: 'It returns fields list of specific data depot.',
    params: [
      { ...params.account },
      params.pretty,
      { ...params.data_depot_name }
    ]
  },
  {
    val: 'connect_to_selected_db',
    category: 'Database',
    method: 'get',
    desc: 'When a new template is created and template property is database then it will help in  establishing the connection  with the selected pdc from the dropdown list',
    params: [
      { ...params.account },
      params.direction,
      { ...params.pdc_name }
    ]
  },
  {
    val: 'get_database_table_info',
    category: 'Database',
    method: 'get',
    desc: 'When the pdc is successfully connected then this api will give the list of tables in the database.',
    params: [
      { ...params.account },
    ]
  },
  {
    val: 'get_database_column_info',
    category: 'Database',
    method: 'get',
    desc: 'When the pdc is successfully connected then this api will give the list of columns in the selected table',
    params: [
      { ...params.account },
      { ...params.table_name }
    ]
  },
  {
    val: 'get_pluginList',
    category: 'Plugin',
    method: 'get',
    desc: 'It returns plugins list in JSON format.',
    params: [
      { ...params.account },
    ]
  },
  {
    val: 'get_pluginDetails',
    category: 'Plugin',
    method: 'get',
    desc: 'It returns plugin detials in JSON format.',
    params: [
      { ...params.account },
      { ...params.pluginName }
    ]
  },
  {
    val: 'get_data_type_versions',
    category: 'Utilities',
    method: 'get',
    desc: 'It returns the list of data type versions available in JSON format and also returns Message Type.',
    params: [
      { ...params.account },
      { ...params.data_type },
      params.pretty,
      params.structOnly
    ]
  },
  {
    val: 'get_trans_sets',
    category: 'Utilities',
    method: 'get',
    desc: 'It returns the list of trans sets correspondind to data type versions ',
    params: [
      { ...params.data_type },
      { ...params.data_type_version },
      { ...params.account }
    ]
  },
  {
    val: 'get_trigger_event_combo_values',
    category: 'Utilities',
    method: 'get',
    desc: 'It returns trigger events in JSON format.',
    params: [
      { ...params.data_type_version, "sample": '25' },
      params.message_type,
      params.pretty,
      params.structOnly
    ]
  },
  {
    val: 'get_latest_user_revision_history',
    category: 'Utilities',
    method: 'get',
    desc: 'It returns latest user revision history',
    params: [
      { ...params.account },
      { ...params.path }
    ]
  },
  {
    val: 'get_user_revision_history',
    category: 'Utilities',
    method: 'get',
    desc: 'It returns user revisions history',
    params: [
      { ...params.account },
      { ...params.path },
      params.pretty
    ]
  },
  {
    val: 'get_user_template_by_revision_history_id',
    category: 'Utilities',
    method: 'get',
    desc: 'It returns template revision history for specific id',
    params: [
      { ...params.account },
      { ...params.path },
      params.pretty,
      params.revid,
      params.user_revid
    ]
  },
  {
    val: 'get_documentation_list',
    category: 'Utilities',
    method: 'get',
    desc: 'It returns help page tree list.',
    params: [
      { ...params.language },
      params.search_str,
      { ...params.account },
      params.pretty
    ]
  },
  {
    val: 'get_accounts',
    category: 'Utilities',
    method: 'get',
    desc: 'It returns all the accounts.',
    // params: [
    //   { ...params.user, sample: 'admin' }
    // ]
  },
  {
    val: 'validate_inbound_template',
    category: 'Utilities',
    method: 'get',
    desc: 'The endpoint needs to accept an unsaved template and validate it, so that frontend can display to the user that it can be saved. Frontend will also need to receive an array of Warnings Found, which will be listed in the “Display Selected Warnings dialog',
    params: [
      { ...params.account },
      { ...params.template_name },
      { ...params.workflow_group_name }
    ]
  },
  {
    val: 'get_session_var_names',
    category: 'Utilities',
    method: 'get',
    desc: 'It will return list of workflow items and their session values according to the selected workflow.',
    params: [
      params.account,
      { ...params.workflow_group_name, sample: 'oauth2' },
      { ...params.workflow_name, sample: 'auth' }
    ]
  },
  {
    val: 'validate_date_pattern',
    category: 'Utilities',
    method: 'get',
    desc: 'The API is designed to accept a date pattern as a parameter. It then performs a validation check on the provided pattern to ensure its correctness. If the pattern is valid, the API will generate and return today date formatted according to the specified pattern. This allows users to obtain the current date in a customized format that meets their specific requirements.',
    params: [
      params.date_pattern
    ]
  },
  {
    val: 'number_formatter',
    category: 'Utilities',
    method: 'get',
    desc: 'It return the test result according to the given pattern and test value. Note :- Pattern should be in encoded format for getting correct result',
    params: [
      { ...params.account },
      params.data_string,
      params.pattern,
      params.precision_value,
      params.check_box
    ]
  },
  {
    val: 'get_searched_document_formatted',
    category: 'Utilities',
    method: 'get',
    desc: 'It return the searched keyword from the document list on the help panel.',
    params: [
      { ...params.account },
      {...params.keyword},
      {...params.source_doc}
    ]
  },
  {
    val: 'search_documentation',
    category: 'Utilities',
    method: 'get',
    desc: 'It will return the search docuement list on the help panel.',
    params: [
      { ...params.account },
      {...params.keyword},
      {...params.language}
    ]
  },
  {
    val: 'record_data_portioning_exact',
    category: 'Utilities',
    method: 'post',
    desc: 'Testing the exact data portioning',
    params: [
      { ...params.account }
    ],
    body: [
      params.exact_portioning_type,
      params.start_position,
      params.no_of_chars,
      params.parse,
      params.test_data_exact
    ]
  },
  {
    val: 'record_data_portioning_relative',
    category: 'Utilities',
    method: 'post',
    desc: 'Testing the relative data portioning',
    params: [
      { ...params.account }
    ],
    body: [
      params.relative_portioning_type,
      params.start_value,
      params.end_value,
      params.start_occurrence,
      params.end_occurrence,
      params.parse,
      params.test_data_relative
    ]
  },
  {
    val: 'create_dtd_inbound_template',
    category: 'Utilities',
    method: 'post',
    isUpload: true,
    desc: 'After the upload and on success of validate dtd file and provide the root element and new dtd template',
    params: [
      { ...params.account },
      params.root_element,
      params.filename,
      { ...params.workflow_group_name },
      { ...params.template_name }
    ]
  },
  {
    val: 'validate_dtd_file',
    category: 'Utilities',
    method: 'post',
    isUpload: true,
    desc: 'This will validate that the file which is uploaded is a valid dtd file or not while creating the new dtd template from new template wizard.',
    params: [
      { ...params.account }
    ]
  },
  {
    val: 'quick_add_field',
    category: 'Utilities',
    method: 'post',
    isUpload: true,
    desc: 'The API, accepting record delimiter, field delimiter, and file as parameters, will parse the input file and provide data for a quick add field grid addition based on the selected delimiters. Files in .xlsx and .docx formats are not permissible.',
    params: [
      params.record_delimiter,
      params.field_delimiter
    ]
  },
  {
    val: 'quick_add_customize_screen',
    category: 'Utilities',
    method: 'post',
    desc: 'This API takes template type and hl7 as a parameter and manage customize logic used for pasting data in quick field add grid',
    params: [
      params.template_type,
      params.hl7
    ],
    body: []
  }

]

export function getApiObject(str) {
  return availableAPIs.filter(o => o.val === str)[0];
}